var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-45 12.328 4.793)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2a2 2 0 1 1 0 4H4a2 2 0 1 1 0-4h8ZM4.093 3h-.325v.837H3v.322h.768V5h.325v-.841h.769v-.322h-.769V3Zm7.407.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z",
  fill: "#f29046"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#f29046",
  cx: 4,
  cy: 4,
  r: 3.5
}))));
export default SvgServo;